<template>
	<el-dialog :title="'文件审查'" :close-on-click-modal="false" :visible.sync="visible"
		width="600px">
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px" :inline="true">
					<el-form-item label="审查时间" prop="examineTime">
						<el-date-picker class="selItemInput" value-format="yyyy-MM-dd"
										v-model="dataForm.examineTime" type="date" style="width:300px">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="审查意见" prop="examineSuggestion">
						<el-input class="selItemInput" type="textarea" v-model="dataForm.examineSuggestion" placeholder="审查意见"
								  style="width:300px">
						</el-input>
					</el-form-item>

		</el-form>
		<el-row class="formBtnGroup">
			<el-button v-preventReClick class="primaryPlainBtn" type="primary" plain @click="visible = false">取消</el-button>
			<el-button v-preventReClick class="primaryPlainBtn" type="primary" @click="dataFormSubmit()">确定</el-button>
		</el-row>
	</el-dialog>

</template>

<script>
	export default {
		name: "examination-audit",
		data() {
			return {
				visible: false,
				inline: false,
				dataForm: {
					recNo: '',
					examineSuggestion: '',
					examineTime: '',
				},
				dataRule: {
					examineTime: [
						{ required: true, message: "请选择审查时间", trigger: "change" }
					],
					examineSuggestion: [
						{ required: true, message: "请输入审查意见", trigger: "blur" }
					],
				},
			}
		},
		methods: {
			init(id) {
				// console.log(id, 'id');
				this.dataForm = {
					examineTime: '',
					examineSuggestion: '',
				};
				this.dataForm.recNo = id?id:0;
				this.$nextTick(() => {
					this.visible = true;
					this.$refs['dataForm'].resetFields();
					this.$http({
						url:  this.$store.state.httpUrl +`/business/fileexamineinfo/info/${this.dataForm.recNo}`,
						method: 'get',
						params: this.$http.adornParams({
							recNo: this.dataForm.recNo
						})
					}).then(({data}) => {
						if (data && data.code === 200) {
							// console.log("20000000");
							this.dataForm.examineSuggestion= data.body.examineSuggestion;
							this.dataForm.examineTime= data.body.examineTime;
						}
					})
				});
			},
			//表单提交
			dataFormSubmit() {
				// console.log("表单提交");
				this.$refs["dataForm"].validate(valid => {
					if (valid) {
						this.$http({
							url:  this.$store.state.httpUrl + "/business/fileexamineinfo/examine",
							method: "post",
							data: this.$http.adornData(
									{
										examineSuggestion: this.dataForm.examineSuggestion,
										examineTime: this.dataForm.examineTime,
										recNo: this.dataForm.recNo,
									}
							)
						}).then(({ data }) => {
							if (data && data.code === 200) {
								this.$message({
									message: "操作成功",
									type: "success",
									duration: 1500,
									onClose: () => {
										this.visible = false;
										this.$parent.getDataList();
									}
								});
							} else {
								this.$message.error(data.msg);
							}
						});
					}
				});
			}
		}
	}
</script>
<style scoped>

</style>
